module.exports = __webpack_public_path__ + "9f1b62e6bcd341ae8cf19e3005ce01a0.png";